import React from 'react';
import './footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { label: 'About', href: '#about' },
    { label: 'Skills', href: '#skills' },
    { label: 'Projects', href: '#projects' },
    { label: 'Experience', href: '#experience' },
    { label: 'Contact', href: '#contact' },
  ];

  const socialLinks = [
    {
      icon: 'bx bxl-linkedin-square',
      href: 'https://www.linkedin.com/in/harshvardhan-sharma-88b414256',
      label: 'LinkedIn',
    },
    {
      icon: 'bx bxl-github',
      href: 'https://github.com/Harshvardhan2164',
      label: 'GitHub',
    },
    {
      icon: 'bx bxl-instagram',
      href: 'https://www.instagram.com/hvs_harshvardhan21',
      label: 'Instagram',
    },
    {
      icon: 'bx bxl-twitter',
      href: 'https://www.twitter.com/Harshvardhan123',
      label: 'Twitter',
    },
  ];

  return (
    <footer className="footer">
      <div className="footer__container container">
        <div className="footer__top">
          <div className="footer__brand">
            <a href="#home" className="footer__logo">
              <span className="footer__logo-bracket">&lt;</span>
              <span className="footer__logo-text">HVS</span>
              <span className="footer__logo-bracket"> /&gt;</span>
            </a>
            <p className="footer__tagline">
              Building impactful solutions with code and data.
            </p>
          </div>

          <div className="footer__links">
            <h4 className="footer__links-title">Quick Links</h4>
            <ul className="footer__links-list">
              {footerLinks.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="footer__link">{link.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer__social-section">
            <h4 className="footer__links-title">Connect</h4>
            <div className="footer__social">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  className="footer__social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                >
                  <i className={social.icon}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="footer__divider"></div>

        <div className="footer__bottom">
          <span className="footer__copy">
            &copy; {currentYear} Harshvardhan Sharma. All Rights Reserved.
          </span>
          {/* <span className="footer__credit">
            Designed & Built with <span className="footer__heart">♥</span>
          </span> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;